<div class="table-responsive mb-3">
  <table class="table table-sm align-middle excel-import-source-rows">
    <caption class="caption-top">
      <span class="fw-bold">{{ texts().title }}</span>
      <span class="d-block small text-muted">{{ texts().help }}</span>
    </caption>
    <thead>
      <tr>
        <th scope="col">{{ texts().label }}</th>
        @for (year of years(); track year) {
          <th scope="col" class="text-end">
            {{ columnLabels()[year] ?? year }}
          </th>
        }
        <th scope="col">{{ texts().slot }}</th>
      </tr>
    </thead>
    <tbody>
      @for (row of rows(); track row.key; let i = $index) {
        <tr>
          <th scope="row">
            {{ row.label }}
            @if (row.source) {
              <span class="d-block small text-muted fw-normal">
                {{ texts().source }}: {{ row.source }}
              </span>
            }
          </th>
          @for (year of years(); track year) {
            <td class="text-end">
              @if (row.amounts[year] !== undefined) {
                {{ row.amounts[year] | number: '1.0-0' : 'sv' }}
              } @else {
                <span class="text-muted" aria-hidden="true">–</span>
              }
            </td>
          }
          <td>
            <lib-vinnova-dropdown
              [id]="idPrefix() + '-row-' + i"
              [items]="slotOptions()"
              [ngModel]="row.slot"
              (ngModelChange)="slotChange.emit({ key: row.key, slot: $event })"
            ></lib-vinnova-dropdown>
            @if (row.withheldSuggestionLabel) {
              <span class="d-block small text-muted">
                {{ texts().suggested }}: {{ row.withheldSuggestionLabel }}
              </span>
            }
            @if (row.sharesSlotWith > 0) {
              <span class="d-block small text-muted">
                {{ texts().summed }}
              </span>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
